export default __webpack_public_path__ + "static/media/guiaIphone1.9fb2ffa1.png";